import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { userMenuTxt } from 'config/translate/variables';
import CartAction from 'actions/Cart';
import userIcn from 'images/menu/user.svg';
import LoginRegister from 'components/Header/LoginRegister';
import RepeatLastOrder from 'components/RepeatLastOrder';
import OrderTracking from 'components/Header/OrderTracking';

const UserLinks = (props) => {
    const {logged, firstName, closeMenuUrl} = props;
    const [show, setShow] = useState(false);

    const logout = () => {
        CartAction.logout(()=> {CartAction.logoutRedirect()});
    }

    return (
        <section className={'new-mobile-menu-account' + (!logged ? ' logout ' : '')}>
            {(!logged) && <div className={"new-mobile-menu-account-btns"}>
                <LoginRegister/>
            </div>}
            {(logged && firstName) &&
            <>
                <div className="last-order user-account" onClick={() => setShow(true)}>
                    <span className="menu-options-title">
                        <div dangerouslySetInnerHTML={{ __html: userIcn }} className="menu-icon"></div>{userMenuTxt.account}
                    </span>
                    <i className="font-icn arrow-up" />
                </div>
                <OrderTracking />
                <RepeatLastOrder />

                {<div className={"my-account-menu " + (show ? ' open ' : '')}>
                    <button className="my-account-title-wrap" onClick={() => setShow(false)}>
                        <i className="font-icn arrow-up"></i> 
                        <span className="my-account-title"> Mi cuenta</span>
                    </button>

                    <ul className="my-account-items-wrap">
                        <li><Link className="my-account-item-text" to="/_secure/account" onClick={() => closeMenuUrl('/_secure/account')}>{userMenuTxt.info}</Link></li>
                        <li ><Link className="my-account-item-text" to="/_secure/compras" onClick={() => closeMenuUrl('/_secure/compras')}>{userMenuTxt.orders}</Link></li>
                        <li><Link className="my-account-item-text"  to="/_secure/listas-de-compras" onClick={() => closeMenuUrl('/_secure/listas-de-compras')}>{userMenuTxt.lists}</Link></li>
                        <li><Link className="my-account-item-text"  to="/mis-tarjetas" onClick={() => closeMenuUrl('/mis-tarjetas')}>{userMenuTxt.cards}</Link></li>
                        <li onClick={logout}><a className="my-account-item-text log-out" >{userMenuTxt.logout}</a></li>
                    </ul>
                </div>}
            </>
            }
        </section>
    );
}

UserLinks.propTypes = {
    logged: PropTypes.string,
    firstName: PropTypes.string,
    closeMenuUrl: PropTypes.func,
};

export default UserLinks;
